/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.health.conditions'},
});

const ConditionsItem = () => (
  <RouteLinkItem
    route="midas/settings/health/conditions"
    title={messages.title}
  />
);

export default ConditionsItem;
